import type { IInactivatedReasonDB } from '@/types/referential';

const NON_DELEGABLE_EXCLUDED_REASON_SLUGS = new Set(['autre', 'demena']);

export const getNonDelegableInactivatedReasons = (
	reasons: IInactivatedReasonDB[]
) =>
	reasons.filter(
		(reason) => !NON_DELEGABLE_EXCLUDED_REASON_SLUGS.has(reason.slug)
	);
